import Cookies from "js-cookie";
import { AuthCheck } from "./HelperFuntions";

// Api Url's for the API's
export const serverUrl = "https://portal.amprex.in/S0001/api/v1/";

// export const serverUrl = "https://dev.shreenaths.com/S0001/api/v1/";
// export const serverUrl = "https://4dxf2015-4200.inc1.devtunnels.ms/S0001/api/v1/";
// export const serverUrl = "https://lrxtv5pv-4200.inc1.devtunnels.ms/S0001/api/v1/";


// Api's Function..

export const callApi = async (url, options) => {
  // dispatch(setLoading(true));

  let token = Cookies.get("token");

  const isTokenExpired = (t) => {
    if (!t) return false;
    try {
      const payload = JSON.parse(atob(t.split('.')[1]));
      return payload.exp < (Math.floor(Date.now() / 1000) + 5);
    } catch (e) {
      return false;
    }
  };

  if (token && isTokenExpired(token)) {
    token = await AuthCheck(serverUrl);
    if (!token) {
      throw new Error("Session expired. Please login again.");
    }
  }

  let headers;
  const API = serverUrl + url;

  if (options?.data) {
    headers = { "Content-Type": "application/json" };
  } else {
    headers = "";
  }
  // console.log(token)
  try {
    const raw = await fetch(API, {
      headers: {
        ...(token &&
          token !== undefined && { Authorization: `Bearer ${token}` }),
        ...headers,
        // "Content-Type": "application/json",
      },
      method: options?.method || "GET",
      body: options?.data
        ? JSON.stringify(options?.data)
        : options?.form_data
          ? options?.form_data
          : undefined,
    });
    // console.log("raw>>>>>>>>>",raw);//

    const data = await raw.json();
    // console.log("raw>>>>>>>>>>", raw);
    // console.log("dataaaaaaaa>>>>>>>>", data);

    // console.log("api error", data);
    if (!raw.ok) {
      if (
        raw?.status == 401 ||
        raw.message == "jwt expired" ||
        raw.message == "jwt malformed" ||
        data?.message == "jwt expired" ||
        data?.message == "jwt malformed" ||
        data?.message == "Token not found" ||
        data?.message?.toLowerCase()?.includes("token not found")
      ) {
        const newToken = await AuthCheck(serverUrl);
        if (newToken) {
          const retryResponse = await fetch(serverUrl + url, {
            method: options?.method || "GET",
            headers: {
              Authorization: `Bearer ${newToken}`,
              "Content-Type": options?.formData
                ? "multipart/form-data"
                : "application/json",
            },
            body: options?.formData
              ? options?.data
              : options?.data
                ? JSON.stringify(options?.data)
                : undefined,
          });
          const responseData = await retryResponse.json();
          return responseData;
        } else {
          throw new Error("Session expired. Please login again.");
        }
      }
      if (raw?.status == 503) {
        throw new Error("Server is restarting");
      } else {
        throw new Error(data?.message);
      }
    }
    return data;
  } catch (error) {
    // let errorStatus = JSON.parse(error.response);
    console.log("error>>>>>>>>>", error);

    return error;

    // return error;
  } finally {
    // dispatch(setLoading(false))
  }
};
